<template>
  <div>
    <preamble v-bind="preamble" />
    <pop v-bind="popContent" v-on:popClose="closePop" />
    <section class="main">
        <div class="container">
            <div class="columns">
                <div class="column is-8 is-offset-2">
                    <div class="columns mb-3">
                    </div>
                    <div class="columns">
                        <div class="column" v-for="(image, index) in aboutImages" :key="index"
                            v-bind:class="{ 'is-8': (index % 2) < 0, 'is-4': (index % 2) > 0 }"
                            >
                            <div class="chapter bg-black">
                                <img v-bind:src="image" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns">
                <div class="column is-8 is-offset-2">
                    <div class="columns mt-1 mb-3">
                        <div class="column is-10 is-offset-2">
                           <div v-if="about.longDescription" v-html="about.longDescription"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns sponsers">

                <div class="column is-8 is-offset-2">
                    <div class="columns">
                        <div class="column is-2"><span class="dash"></span></div>
                        <div class="column is-8"><div><h3>Partners and Sponsors</h3></div></div>
                    </div>
                    <div class="columns">
                        <div class="column is-3" v-for="(logo, index) in sponsorRowOne" :key="index">
                            <div class="">
                                <img v-bind:src="logo" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-3" v-for="(logo, index) in sponsorRowTwo" :key="index">
                            <div class="">
                                <img v-bind:src="logo" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-3" v-for="(logo, index) in sponsorRowThree" :key="index">
                            <div class="">
                                <img v-bind:src="logo" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
  </div>
</template>
<script>
    import Preamble from '@/components/Preamble.vue'
    import Pop from '@/components/Pop.vue'
    import sharedMethodsMixin from '@/mixins/sharedMethodsMixin'
    import { resources, API } from '@/utils/constants'

    export default {
        name: "About",
        mixins: [sharedMethodsMixin],
        components: {
                Preamble, Pop    
                },
        data() {
            return {
              about: {},
              aboutImages: [],
              sponsors: [],
              preamble: {
                title: 'About',
                subTitle: '...',
                secondaryTitle: '',
                description: '',
                watchVideo: '',

              },
              popContent: {
                triggered: false,
                title: '',
                description: '',
              },
              currentLine: {
                id: '101',
                year: '1968',
                title: 'The disease now has a name: "Slim"',
                shortDescription: '“A neighbour and later her boyfriend die in Makindye after suffering from a strange disease”. First memories of a strange disease manifesting symptoms similar to AIDS.',
                longDescription: '', // will come back to this
                image: '' // will come back to this
              },
              timeLine : [
                {
                  id: '',
                  year: '',
                  title: '',
                  shortDescription: '',
                  longDescription: '', 
                  image: ''
                }
              ]
            }
        },
        created() {

          this.read(`${resources.about}`)
                    .then(response => {
                    this.about = response.data[0]

                    this.preamble = {
                            title: this.about.title, 
                            subTitle: this.about.tagLine,
                            secondaryTitle: this.about.subTitle,
                            description: this.about.shortDescription,
                            watchVideo: this.about.videoLink,
                        }
                    if(this.about.images){
                        this.aboutImages = this.about.images.split(', ').map(image => `${API}${image}`)
                    }
                })
                
            this.read(`${resources.sponsors}`)
                    .then(response => {

                    if(response.data[0].logos){
                        this.sponsors = response.data[0].logos.split(', ').map(image => `${API}${image}`)
                    }
                    console.log(this.sponsors)
                })
        
        },
        mounted() {
            
        },
        methods: {
          handleTimelineMove(currentId, direction) {
            const TotalItems = this.timeLine.length;

            if(direction){
              const currentTimelineIndex = this.timeLine.findIndex(lineItem => lineItem.id === currentId);
              if(direction === 'right') {

                
                if (currentTimelineIndex >= (TotalItems - 1)){
                  this.currentLine = this.timeLine[0]
                } else {
                  this.currentLine = this.timeLine[(currentTimelineIndex + 1)]
                }
              } else {
                if (currentTimelineIndex <= 0){
                  this.currentLine = this.timeLine[(TotalItems - 1)]
                } else {
                  this.currentLine = this.timeLine[(currentTimelineIndex - 1)]
                }
              }

            } else {
              const selectedLineItem = this.timeLine.find( ({ id }) => id === currentId );
              this.currentLine = selectedLineItem
            }


            
          },

          handlePop() {
            this.popContent = {...this.currentLine, triggered: true}
          },

          closePop() {
            this.popContent.triggered = false;
          }
        },
        computed: {
            sponsorRowOne() {
                return this.sponsors.slice(0, 4);
            },
            sponsorRowTwo() {
                return this.sponsors.slice(4, 8);
            },
            sponsorRowThree() {
                return this.sponsors.slice(8, 12);
            } 
        },
    }
</script>

<style>
</style>
